/** Gerunds for “thinking” — desk assist busy state only. */
export const ASSIST_THINKING_LABELS = [
    'Pensando',
    'Riflettendo',
    'Ragionando',
    'Meditando',
    'Rimuginando',
    'Ruminando',
    'Rimeditando',
    'Ponderando',
    'Considerando',
    'Valutando',
    'Soppesando',
    'Escogitando',
    'Cogitando',
    'Elucubrando',
    'Congetturando',
    'Speculando',
    'Ratiocinando',
    'Arrovellando',
    'Sillogizzando',
    'Discettando',
    'Deliberando',
    'Ideando',
    'Concependo',
    'Filosofando',
];

/**
 * @param {string[]} pool
 * @param {string|null} exclude
 */
export function pickRandomThinkingLabel(pool, exclude) {
    const candidates = exclude
        ? pool.filter((label) => label !== exclude)
        : pool.slice();

    if (candidates.length === 0) {
        return pool[0] || 'Pensando';
    }

    return candidates[Math.floor(Math.random() * candidates.length)];
}
